import classNames from "classnames";
import scss from "@/styles/pages/terms/terms-hero.module.scss"

export const wrapper = classNames(
  // Mobile
  "mobile:pt-8",
  // Tablet  
  "tablet:pt-16",
  // All
    scss["wrapper"]
  );